import React from 'react';
import Title from '../../../components/Title';
import { Button } from 'react-bootstrap';
import Icon from '../../../components/Icon';
import { useTranslation } from 'react-i18next';
import { useGetDmpsQuery } from '../../../api/dmpApiSlice';
import { Loader } from '../../../components/components';
import { useState } from 'react';
import FormButton from '../../../components/forms/FormButton';
import Dmp from '../../../components/dmp/Dmp';
import DmpModal from '../../../components/dmp/DmpModal';

const Dmps = () => {
  const { t } = useTranslation();
  const { data: dmps = [], isSuccess, isLoading } = useGetDmpsQuery();
  const [newModalShow, setNewModalShow] = useState(false);
  const [edit, setEdit] = useState(false);

  return (<>
    <Title main={t("menu.dmps")} group={false}>
      {!edit && <FormButton edit onClick={() => setEdit(true)} />}
      {edit && <Button variant="primary" onClick={() => { setNewModalShow(true) }}>
        <Icon icon='plus' text={t("new")} />
      </Button> }
      {edit && <FormButton cancel onClick={() => setEdit(false)} />}
    </Title>
    {isLoading && <Loader />}
    {isSuccess &&
      dmps.map(dmp => (<Dmp disabled={!edit} onSaved={ () => setEdit(false) } key={dmp.slug} dmp={dmp} />))
    }
    <DmpModal show={newModalShow} onClose={() => { setNewModalShow(false)}}/>
  </>)
}

export default Dmps;
